import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useCrimesChartsDataContext } from './hooks/useCrimesChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const ConductAnualList = () => {
    const { chartData } = useCrimesChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_estatistica',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'conduta',
                header: 'Conduta',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.conductEvolutionAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.condutas.map((conduta) => ({
            ...conduta,
            ano_estatistica: itemAno.ano_estatistica
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Condutas Anuais"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};